export default "__VITE_ASSET__Bokkub5l__"